"use client";

import React, { useState } from "react";
import Text from "@components/atoms/Text";
import Button from "@components/atoms/Button";
import { Carousel } from "@components/molecules/Carousel";
import { AllFeatureCard } from "@components/molecules/AllFeatureCard";
import { TabButton } from "@components/molecules/TabButton";
import styles from "./AllFeaturesCarousel.module.scss";
import { AllFeaturesCarouselProps } from "./AllFeaturesCarousel.types";

export const AllFeaturesCarousel: React.FC<AllFeaturesCarouselProps> = ({
  className = "",
  modelFeatures,
  isSellable,
}) => {
  // Set initial active category to the first category
  const [activeCategory, setActiveCategory] = useState<string>(
    modelFeatures.length > 0 ? modelFeatures[0].categoryName : ""
  );

  const handleCategoryChange = (categoryName: string) => {
    setActiveCategory(categoryName);
  };

  // Find the active category and its features
  const activeCategoryData = modelFeatures.find(
    (category) => category.categoryName === activeCategory
  );
  const activeFeatures = activeCategoryData?.features || [];

  // If no features or categories, don't render
  if (!modelFeatures || modelFeatures.length === 0) {
    return null;
  }

  return (
    <section className={`${styles.allFeaturesCarousel} ${className}`}>
      {/* Bottom Section - Detailed Features */}
      <div className={styles.bottomSection}>
        <div className={styles.categoryTabs}>
          {modelFeatures.map((category) => (
            <TabButton
              key={category.categoryName}
              isActive={activeCategory === category.categoryName}
              label={category.categoryName}
              onClick={() => handleCategoryChange(category.categoryName)}
              className={`${styles.categoryTab} ${
                activeCategory === category.categoryName ? styles.activeTab : ""
              }`}
            />
          ))}
        </div>

        <div className={styles.detailedCarousel}>
          <Carousel heading="" className={styles.detailedCarouselContainer}>
            {activeFeatures.map((feature) => {
              // Transform feature data for AllFeatureCard
              const transformedFeature = {
                id: feature.id.toString(),
                title: feature.displayName || feature.name,
                description: feature.additionalInfo?.feature_value?.value
                  ? `${feature.additionalInfo.feature_value.value}${
                      feature.additionalInfo.feature_value.unit
                        ? ` ${feature.additionalInfo.feature_value.unit}`
                        : ""
                    }`
                  : feature.description || "",
                image:
                  feature.media && feature.media.length > 0
                    ? feature.media[0].url
                    : "",
                availableVariants:
                  feature.availableVariants &&
                  feature.availableVariants.length > 0
                    ? `Available in ${
                        feature.availableVariants.length
                      } variant${
                        feature.availableVariants.length > 1 ? "s" : ""
                      }`
                    : "",
                available: feature.availableVariants,
                category: feature.category,
              };

              return (
                <AllFeatureCard
                  key={feature.id}
                  feature={transformedFeature}
                  isDetailed={true}
                  isSellable={isSellable}
                />
              );
            })}
          </Carousel>
        </div>

        <Button className={styles.ctaButton}>
          <Text className={styles.ctaText}>{`Explore all features`}</Text>
        </Button>
      </div>
    </section>
  );
};
